import { takeEvery, put, call } from "redux-saga/effects";

import * as action from "./actions";
import * as api from "../../apis";

export function* getFailedReports(request: any) {
  try {
    let response = yield call(api.fetchFailedReportStatuses);
    yield put(action.getFailedReportsSuccess(response));
  } catch (e) {
    yield put(action.getFailedReportsFailure());
  }
}

export function* watchGetFailedReports() {
  yield takeEvery(action.GET_FAILED_REPORTS, getFailedReports);
}

export function* resendReport(request: any) {
  try {
    let response = yield call(
      api.resendReport,
      request.payload.merchant_id,
      request.payload.report_id,
      request.payload.report_file_id,
      request.payload.process
    );
    yield put(action.resendReportSuccess(request.payload));
  } catch (e) {
    yield put(action.resendReportFailure(request.payload));
  }
}

export function* watchResendReports() {
  yield takeEvery(action.RESEND_REPORT, resendReport);
}

export function* regenerateReport(request: any) {
  try {
    let response = yield call(api.regenerateReport, request.payload);
    yield put(action.regenerateReportSuccess(request.payload));
  } catch (e) {
    yield put(action.regenerateReportFailure(request.payload));
  }
}

export function* watchRegenerateReport() {
  yield takeEvery(action.REGENERATE_REPORT, regenerateReport);
}

export function* regenerateSystemFailures(request: any) {
  try {
    let response = yield call(api.regenerateSystemFailures);
    yield put(action.regenerateSystemFailuresSuccess());
  } catch (e) {
    yield put(action.regenerateSystemFailuresFailure());
  }
}

export function* watchRegenerateSystemFailures() {
  yield takeEvery(action.REGENERATE_SYSTEM_FAILURES, regenerateSystemFailures);
}



// WEBPACK FOOTER //
// ./client/modules/Admin/sagas.ts